import React, { useState } from 'react';
import SearchInput from 'src/components/search-input/search-input';
import ClientManagementTable from '../components/client-management-table';
import { Button } from 'src/components/ui/button';
import { Plus } from 'lucide-react';
import ClientCreationComponent from '../components/client-creation/client-creation-component';
import { Account, Campaign } from '../types/client-management.types';
import { Company } from 'src/pages/billing/types/billing.types';
import { useGetOrganizationClientsQuery } from 'src/redux/organization/organization.endpoints';

const ManageClientsTab: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const [selectedCompanies, setSelectedCompanies] = useState<Company[]>([]);
  const [selectedAccounts, setSelectedAccounts] = useState<Account[]>([]);
  const [selectedCampaigns, setSelectedCampaigns] = useState<Campaign[]>([]);
  const [showClientCreationComponent, setShowClientCreationComponent] = useState(false);

  const { data: clients } = useGetOrganizationClientsQuery();

  const handleClientSelect = (companies: Company[], accounts: Account[], campaigns: Campaign[]) => {
    setSelectedCompanies(companies);
    setSelectedAccounts(accounts);
    setSelectedCampaigns(campaigns);
  };

  return (
    <div className="h-full flex flex-col space-y-4">
      {/* Header */}
      <div className="">
        <div className="flex flex-row gap-4 w-full items-center justify-between pb-1">
          <div>
            <SearchInput
              placeholder="Search invoices..."
              value={searchValue}
              onChange={setSearchValue}
              debounceMs={500}
              className="w-96 rounded-full"
              inputClassName='bg-white rounded-full '
            />
          </div>
          <div className="flex items-center gap-2">
            {/* <StyledDropdown
              options={getDropdownOptions()}
              selectedValue={selectedGroupId}
              onSelect={handleDropdownSelect}
              placeholder="Select Month"
              buttonVariant="primary"
              isLoading={!invoiceGroupsData}
              buttonClassName='rounded-full bg-gray-201 text-gray-700'
            /> */}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="overflow-auto relative rounded-lg shadow-md">
        <div className='flex flex-row gap-2 justify-end bg-white border-b border-gray-201'>
          <Button
            size='med'
            variant='ghost'
            onClick={(() => {
              setShowClientCreationComponent(!showClientCreationComponent);
            })}
            className={`flex flex-col hover:bg-gray-201 rounded-none p-8 px-4 pb-8 text-sm gap-1 border-l border-gray-201 ${showClientCreationComponent ? 'bg-gray-201' : ''}`}
          >
            <Plus className="h-4 w-4" />
            New
          </Button>
        </div>
        {showClientCreationComponent && (
          <div className='overflow-visible'>
            <ClientCreationComponent
              isCreate={true}
            />
          </div>
        )}
        <div className='overflow-visible'>
          <ClientManagementTable
            clients={clients ?? []}
            isCreation={showClientCreationComponent}
            className='overflow-visible'
          />
        </div>

      </div>


    </div>
  );
};

export default ManageClientsTab;
